import { createAction } from 'typesafe-actions';

export const toggleIsByCommercialOwnerAction = createAction('filters/isByCommercialOwnerChanged')();
